<template>
  <v-toolbar>
      <v-tabs align-with-title light>
        <v-tabs-slider color="blue"></v-tabs-slider>

        <v-tab
          v-for="(tab, i) in tabs"
          :key="`tab-${i}`"
          @click="$router.push({ name: tab.link })"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>
    <!-- <v-list class="tabs-wrapper" height="40">
      <v-list-item-group class="d-flex" v-model="selectedTab" mandatory>
        <v-list-item
          v-for="(tab, i) in tabs" :key="`tab-${i}`"
          :value="tab.link"
          @click="$router.push({ name: tab.link })"
          class="tab flex text-center font-size-medium-large"
          active-class="selected-tab">
          <span class="ma-auto"
                :class="{'white--text': tab.link !== selectedTab}">
            {{tab.title}}
          </span>
        </v-list-item>
      </v-list-item-group>
    </v-list> -->
<!--    <v-spacer/>-->
<!--    <cvc-actions/>-->
  </v-toolbar>
</template>

<script>
  import CvcActions from "@/components/CvcActions";
  export default {
    components: {CvcActions},
    data () {
      return {
        cvcIcon: require('../assets/Covatic.png'),
        selectedTab: null,
        tabs: [
          {title: "Estimator", link: "AdvertisingEstimator"},
          {title: "Segments", link: "AdvertisingSegments"},
        ]
      }
    },
    mounted() {
      this.selectedTab = this.$route.name;
    },
  }
</script>

<style lang="scss" scoped>
  .toolbar {
    position: relative;
    width: 100%;
    z-index: 991;
    background: none !important;
    .v-toolbar__content {
      padding: 0 !important;
    }
  }
  .tabs-wrapper {
    position: absolute;
    display: flex;
    top: 0;
    margin-left: -16px;
    padding: 0;
    background: none !important;
  }
  .tab {
    display: flex;
    margin: 0 8px 0 0;
    background-color: #1F6ADA;
    min-height: 44px !important;
    height: 44px;
    width: 270px;
  }
  .selected-tab {
    height: 50px;
    padding-bottom: 14px;
    color: #02092E !important;
    background-color: #F7F7FC !important;
    &:before {
      color: #02092E !important;
      background-color: #F7F7FC !important;
    }
  }
</style>